import React from "react";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import {ToggleWrapper, ToggleDescription} from "../styles/sharedComponentStyles"

export default ({
    value,
    setValue,
    description,
    trueOption,
    falseOption
    }) => {

    return(
        <ToggleWrapper>

             {description != null &&
                 <ToggleDescription>
                     <small>
                         {description}
                     </small>
                 </ToggleDescription>
             }

            <ToggleButtonGroup
                color="primary"
                value={value}
                exclusive
                onChange={(event, newValue) => newValue != null && setValue(newValue)}
            >
                <ToggleButton value={true}>{trueOption}</ToggleButton>
                <ToggleButton value={false}>{falseOption}</ToggleButton>
            </ToggleButtonGroup>

        </ToggleWrapper>
    )
}